import React from 'react';
import { Container } from 'react-bootstrap';

function LinkInvitationStep6() {
  return (
    <Container className="text-center mt-5">
      <h1 className="text--blue2 mb-4">¡Gracias! </h1>
      <p className="text--black5">
        Para volver a consultar la documentación de forma segura,
        por favor utilice el enlace que recibió en su bandeja de
        correo electrónico o recargue esta página
        <br />
      </p>
    </Container>
  );
}

export default LinkInvitationStep6;
